import { memo } from 'react';

import { MemberAdd } from '@air/next-icons';
import { Badge } from '@air/primitive-badge';
import { DropdownMenuItem } from '@air/primitive-dropdown-menu';

export type WorkspaceHeaderInformationDropdownTeamInviteNudgeProps = {
  onInviteMembers: () => void;
};

export const WorkspaceHeaderInformationDropdownTeamInviteNudge = memo(
  ({ onInviteMembers }: WorkspaceHeaderInformationDropdownTeamInviteNudgeProps) => (
    <>
      <div className="-mx-2 -mt-2 bg-blue-1 px-3 py-3" data-testid="WORKSPACE_DROPDOWN_TEAM_INVITE_NUDGE">
        <p className="font-semibold text-14 text-gray-12">Gather your team in Air</p>
        <p className="mt-1 text-14 text-gray-12">All plans have unlimited seats to make collaboration seamless.</p>
      </div>
      <DropdownMenuItem
        data-id="INVITE_USERS"
        label="Invite users"
        onSelect={onInviteMembers}
        prefix={<MemberAdd className="size-4" />}
        suffix={
          <Badge className="shrink-0" color="blue">
            Unlimited
          </Badge>
        }
      />
    </>
  ),
);

WorkspaceHeaderInformationDropdownTeamInviteNudge.displayName = 'WorkspaceHeaderInformationDropdownTeamInviteNudge';
